import { ThemeMode } from '@fleet-beat/core';

export interface AddDocumentsDialogOptions {
  currentThemeMode: ThemeMode;
  userID?: string;
  truckID?: string;
  title?: string;
  requireDocument?: boolean;
}
